import React from 'react';
import { css } from 'emotion';
import { ShortArrowLeft, ArrowLeft, ArrowRight, Eye } from '../../Layout/icons';
import { Link } from 'react-router-dom';
import config from '../../../config';

const ProfileHeader = ({ status, didSomethingChange, article, onSubmit }) => {
  const styles = {
    container: css({
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
    }),
  };

  //   const btnStatusColors = {
  //     published: 'success',
  //     draft: 'secondary',
  //     unpublished: 'warning',
  //   };

  const statuses = {
    draft: {
      otherStatuses: [{ label: 'Publish article', name: 'published' }],
      currentStatus: { label: 'Save Changes', name: 'draft' },
    },
    published: {
      otherStatuses: [{ label: 'Unpublish article', name: 'unpublished' }],
      currentStatus: { label: 'Publish changes' },
    },
    unpublished: {
      otherStatuses: [{ label: 'Publish article', name: 'published' }],
      currentStatus: { label: 'Save Changes', name: 'unpublished' },
    },
  };

  return (
    <div className={styles.container + ' my-3'}>
      <div>
        <Link to='/articles' className='btn btn-link '>
          <ShortArrowLeft /> Back to articles
        </Link>
        {/* <button type='button' className='btn btn-link disabled'>
          <ArrowLeft /> Previous Profile
        </button>
        <button type='button' className='btn btn-link disabled'>
          Next profile <ArrowRight />
        </button> */}
      </div>
      <div>
        {' '}
        <a
          type='button'
          className={`btn btn-link ${article ? '' : 'disabled'}`}
          href={config.FRONTEND_URL + '/articles/' + article?._id}
          target='_blank'
          title={'Ctrl+Shift+p'}
        >
          <Eye /> Preview
        </a>
        {/* <button
          type='button'
          type='button'
          className={`btn btn-primary ${didSomethingChange ? '' : 'disabled'}`}
        >
          <Save /> Save
        </button> */}
        <div className='btn-group' role='group'>
          <button
            type='submit'
            title={'Ctrl+S'}
            className={`btn btn-primary ${
              didSomethingChange ? '' : 'disabled'
            }`}
            onClick={(e) => onSubmit(e)}
          >
            {' '}
            {statuses[status].currentStatus.label}
          </button>
          <button
            id='btnGroupDrop1'
            type='button'
            className={`btn btn-primary dropdown-toggle dropdown-toggle-split `}
            data-toggle='dropdown'
          >
            {' '}
            <span className='sr-only'>Toggle Dropdown</span>
          </button>
          <div className='dropdown-menu' aria-labelledby='btnGroupDrop1'>
            {statuses[status].otherStatuses.map((e, i) => (
              <button
                type='submit'
                key={i}
                className='dropdown-item'
                href='!#'
                onClick={(event) => onSubmit(event, e.name)}
              >
                {e.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileHeader;
